import { render, staticRenderFns } from "./navTabs.vue?vue&type=template&id=461e29c4&"
import script from "./navTabs.vue?vue&type=script&lang=js&"
export * from "./navTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports